import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/add-file.svg';
const AddFileIcon = () => React.createElement(IconSvg, null);
export default AddFileIcon;
